import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';

export const SigninButton = ({
  copy,
  onClick,
  icon,
}: {
  copy: string;
  onClick: () => void;
  icon: React.ReactNode;
}) => (
  <div className="google">
    <button
      onClick={onClick}
      type="button"
      className={cs(
        'tw-w-full tw-px-8 tw-py-2',
        'tw-text-sm tw-font-semibold',
        'tw-flex tw-items-center tw-justify-center',
        'tw-rounded tw-bg-neutral-50',
        'tw-border-2 tw-border-solid tw-border-neutral-200',
        'hover:tw-border-neutral-400'
      )}
    >
      {icon}
      <span className="tw-ml-2">{copy}</span>
    </button>
  </div>
);
